import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5df14c12")
const _hoisted_1 = { class: "zone__container" }
const _hoisted_2 = { class: "zone__icon" }
const _hoisted_3 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 115.28 122.88",
  width: "2.5rem"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 100.09h15.03V39.45L.3 41.73 0 22.51l15.03-2.39V2.89c0-1.6 1.29-2.89 2.89-2.89h27.55c1.6 0 2.89 1.29 2.89 2.89v11.93l54.22-8.62 3.07 19.21-6.3.98v5.19l11.36 12.45c.19.2.34.43.45.67h3.52c.33 0 .6.27.6.6v28c0 .33-.27.6-.6.6H76.01c-.33 0-.6-.27-.6-.6V45.29c0-.33.27-.6.6-.6h3.63c.13-.22.3-.43.5-.62L93.8 31.41v-4.16l-45.44 7.04v65.81h15.37v22.79H0v-22.8zM20.81 19.2l9.46-1.5-9.46-8.9v10.4zm15.87-2.52l5.89-.94V5.78H25.11l11.57 10.9zm5.9 18.5l-6.43 1 6.43 6.06v-7.06zM29.7 37.17l-8.89 1.38v3.75l.2.03h14.16l-5.47-5.16zm57.8 7.52h16.4l-7.52-8.24-8.88 8.24zM20.81 82.2c.08.01.16.02.24.04h14.13L20.81 68.7v13.5zm6.59 5.6l13.06 12.29h2.12V87.66c-.22.08-.46.13-.69.13v.01H27.4zm5.56 12.29L20.81 88.65v11.44h12.15zM20.81 62.25c.08.01.16.02.24.04h14.13L20.81 48.76v13.49zm6.59 5.6l15.17 14.29V67.71c-.22.08-.46.12-.69.13v.01H27.4zm0-19.95l15.18 14.29V47.76c-.22.08-.46.13-.69.13v.01H27.4z",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "zone__data" }
const _hoisted_7 = { class: "zone__title" }
const _hoisted_8 = { class: "zone__name" }
const _hoisted_9 = { class: "zone__w3" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isDumpZone)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(`fas ${_ctx.icon} fa-2x`)
          }, null, 2))
        : (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.zoneTitle), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.zone.name), 1),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.zone.w3), 1)
    ])
  ]))
}